import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';
import createMutationsSharer from 'vuex-shared-mutations';

Vue.use(Vuex);

import cart from './modules/cart';
import params from './modules/params';
import slider from './modules/slider';
import api from './modules/api';
import meta from './modules/meta';

export const store = new Vuex.Store({
  plugins: [
    createPersistedState({
      paths: ['cart.cart'],
    }),
    createMutationsSharer({
      predicate: [],
    }),
  ],
  modules: {
    cart,
    params,
    slider,
    api,
    meta,
  },

  strict: process.env.NODE_ENV !== 'production',
});



// WEBPACK FOOTER //
// ./src/store/index.js